import { css } from 'lit';
import componentStyles from '../styles/component.styles';
export default css `
  ${componentStyles}
  /**
--------------------------------------------------
* General
--------------------------------------------------
*/
:host {
    display: block;
  }

  .button-group {
    display: flex;
    align-items: center;
    gap: var(--p-button-group-gap, 15px);
    flex-wrap: wrap;
    margin: var(--p-button-group-margin, 0);
  }

  /**
--------------------------------------------------
* Align
--------------------------------------------------
*/
  .left {
    justify-content: flex-start;
  }

  .center {
    justify-content: center;
  }

  .right {
    justify-content: flex-end;
  }

  .space-between {
    justify-content: space-between;
  }

  .stretch ::slotted(*) {
    flex: 1;
  }

  /**
--------------------------------------------------
* Compact
--------------------------------------------------
*/
  .compact {
    gap: 0;
  }
`;
